import * as React from 'react'
import * as ReactDOM from 'react-dom'

import 'style/global.css'
import 'plume-ui/dist/style.css'
import { isBrowserSupported } from 'helpers/browser-detect'
import { UnsupportedBrowser } from 'components/unsupported-browser/unsupported-browser'
import './utils/i18n/i18n'
import { Exception500 } from 'components/exception/500'
import { AppStore } from 'stores/app-store'
import { ErrorBoundary } from 'react-error-boundary'

const rootNode = document.createElement('div')
rootNode.setAttribute('id', 'root')
document.body.appendChild(rootNode)

export const StoreContext = React.createContext(null)
export const StoreProvider = StoreContext.Provider
export const appStoreContainer: { appStore?: AppStore } = {}

if (!isBrowserSupported()) {
  ReactDOM.render(<UnsupportedBrowser />, rootNode)
} else {
  const { Provider } = require('mobx-react')
  const { Router } = require('react-router-dom')
  const { configure } = require('mobx')
  const { App } = require('app')
  const { AppStore } = require('./stores/app-store')
  const { QueryClientProvider, QueryClient } = require('react-query')

  const queryClient = new QueryClient()

  configure({
    enforceActions: 'observed',
  })

  const appStore = new AppStore()
  appStoreContainer.appStore = appStore

  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <Provider appStore={appStore}>
        <StoreProvider value={appStore}>
          <Router history={appStore.history}>
            <ErrorBoundary fallback={<Exception500 statusCode={null} />}>
              <React.Suspense fallback={null}>
                <App />
              </React.Suspense>
            </ErrorBoundary>
          </Router>
        </StoreProvider>
      </Provider>
    </QueryClientProvider>,
    rootNode,
  )
}
